<div class="container">
  <div class="wrapper">
    <div class="text-wrapper">
      <h2>Рассчитать доставку</h2>
      <div class="description-mobile d-md-none">
        <p>Мы можем предложить более 5 способов доставки</p>
      </div>
      <div class="description-desktop d-none d-md-block">
        <p>
          Привезем стройматериалы по нужному адресу:
          <br />
          курьером, грузовой машиной, с манипулятором и
          <br />
          разгрузкой
        </p>
      </div>
      <ui-custom-generic-link class="detail-link" url="/free_delivery">
        Подробнее о доставке
        <cx-icon class="detail-link-icon" [type]="iconType.ARROW_NAVIGATE"></cx-icon>
      </ui-custom-generic-link>
    </div>
    <form [formGroup]="deliveryCalculatorFormService.form" (submit)="onSubmit()" data-analytics="delivery_calculation">
      <div class="form-group">
        <sd-form-field-new label="Куда будем доставлять?">
          <sd-select>
            <ng-select
              [items]="suggestions$ | async"
              bindLabel="value"
              bindValue="value"
              [loading]="suggestIsLoading$ | async"
              loadingText="Идет поиск..."
              notFoundText="Ничего не найдено"
              typeToSearchText="Начинайте вводить адрес доставки"
              [dropdownPosition]="'bottom'"
              [editableSearchTerm]="true"
              formControlName="address"
              [typeahead]="selectTypeahead"
              [clearable]="false"
              (change)="onChangeSelect($event)"
              (blur)="onBlurSelect($event)"
            ></ng-select>
          </sd-select>
        </sd-form-field-new>
        <cx-form-errors [control]="deliveryCalculatorFormService.form.get('address')"></cx-form-errors>
      </div>
      <div class="d-md-flex control-group form-group">
        <div>
          <sd-form-field-new label="Вес заказа кг">
            <input
              class="field-weight"
              sdOnlyNumber="float"
              type="number"
              [formControl]="deliveryCalculatorFormService.weight"
              [value]="deliveryCalculatorFormService.weight.value"
            />
          </sd-form-field-new>
          <cx-form-errors [control]="deliveryCalculatorFormService.form.get('weight')"></cx-form-errors>
        </div>
        <button sdButton type="primary" size="l" fullWidth="true">Рассчитать</button>
      </div>
      <div class="disclaimer">Точная стоимость доставки рассчитывается при оформлении заказа</div>
    </form>
  </div>
</div>
